import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import table from "@/components/table";
import LoginPage from "@/components/LoginPage";
import SearchView from "@/components/SearchPage";
import CommonPage from "@/components/CommonPage";
import ArticlePage from "@/components/ArticlePage";
import NotFound from "@/components/NotFound";
import SavedSearchPage from "@/components/SavedSearchPage";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/search/saved",
      name: "SavedSearch",
      component: SavedSearchPage
    },
    {
      path: "/search",
      name: "Search",
      component: SearchView,
      props: { isCommon: false }

    },
    {
      path: "/article",
      name: "Article lookup",
      component: ArticlePage,
      props: { }

    },
    {
      path: "/commons",
      name: "Equivalences",
      component: SearchView,
      props: { isCommon: true }
    },
    {
      path: "/table",
      name: "Table",
      component: table
    },
    {
      path: "/login",
      name: "Login",
      component: LoginPage
    },

    {
      path: "*",
      name: "404",
      component: NotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js